import { render } from "./AddForm.vue?vue&type=template&id=c54a2e2e&scoped=true"
import script from "./AddForm.vue?vue&type=script&lang=js"
export * from "./AddForm.vue?vue&type=script&lang=js"

import "./AddForm.vue?vue&type=style&index=0&id=c54a2e2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c54a2e2e"

export default script